import { render, staticRenderFns } from "./detailsInfo3.vue?vue&type=template&id=fbd3b2d4&scoped=true&lang=html&"
import script from "./detailsInfo3.vue?vue&type=script&lang=js&"
export * from "./detailsInfo3.vue?vue&type=script&lang=js&"
import style0 from "./detailsInfo3.vue?vue&type=style&index=0&id=fbd3b2d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd3b2d4",
  null
  
)

export default component.exports